// Author Liang Gang Qiang
// Date 2024-07-29 09:01:06

class SithMesPrdProjectKam {
constructor({
        id = null,
        projectPlanId = '',
        kamId = '',
        baseLineStartTime = '',
        baseLineEndTime = '',
        kamDeadline = '',
        completeTime = '',
        timeOffset = '',
        completeTimeDeviation = '',
        professionalCategory = '',
        engineerLoginName = '',
        technicianLoginName = '',
        participateAssembly = '',
        scope = '',
        materialDirection = '',
        materialNumber = '',
        materialQuantity = '',
        released = '',
        remark = '',
        sapAssignStatus = '',
        sapAssignMsg = '',
        isLocked = '',
        bomCompareResult = '',
        isCritical = ''}
= {}) {
    this.id = id;
    this.projectPlanId = projectPlanId;
    this.kamId = kamId;
    this.baseLineStartTime = baseLineStartTime;
    this.baseLineEndTime = baseLineEndTime;
    this.kamDeadline = kamDeadline;
    this.completeTime = completeTime;
    this.timeOffset = timeOffset;
    this.completeTimeDeviation = completeTimeDeviation;
    this.professionalCategory = professionalCategory;
    this.engineerLoginName = engineerLoginName;
    this.technicianLoginName = technicianLoginName;
    this.participateAssembly = participateAssembly;
    this.scope = scope;
    this.materialDirection = materialDirection;
    this.materialNumber = materialNumber;
    this.materialQuantity = materialQuantity;
    this.released = released;
    this.remark = remark;
    this.sapAssignStatus = sapAssignStatus;
    this.sapAssignMsg = sapAssignMsg;
    this.isLocked = isLocked;
    this.bomCompareResult = bomCompareResult;
    this.isCritical = isCritical;
}
}

function newEntity() {
return new SithMesPrdProjectKam();
}

const allInfoViewENVoConfigs = [
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.projectName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enNetwork',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enNetwork',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'spiridonActivityId',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.spiridonActivityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enNetworkCode',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enNetworkCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enActivityId',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enActivityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enElementName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enElementName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enElementType',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enElementType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'spiridonActivityName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.spiridonActivityName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'engineerName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.engineerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'technicianName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.technicianName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'participateAssembly',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.participateAssembly',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'scope',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.scope',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: 'SAG' },
                            { value: '2', text: 'SITH' },
                            { value: '3', text: 'MIXED' }
            ]
                }
        },
        {
        key: 'materialDirection',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialDirection',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: 'R' },
                            { value: '2', text: '3rd' },
                            { value: '3', text: 'P' }
            ]
                }
        },
        {
        key: 'materialNumber',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialQuantity',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'released',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.released',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.createdByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'sapAssignStatusTranslate',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.sapAssignStatusTranslate',
        sortable: true,
            translateFromField: 'sapAssignStatus',
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'isLocked',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.isLocked',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        }
    ]
const listViewENVoConfigs = [
        {
        key: 'enNetwork',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enNetwork',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'spiridonActivityId',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.spiridonActivityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enNetworkCode',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enNetworkCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enActivityId',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enActivityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enElementName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enElementName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enElementType',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enElementType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'spiridonActivityName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.spiridonActivityName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'engineerName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.engineerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'technicianName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.technicianName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'participateAssembly',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.participateAssembly',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'scope',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.scope',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: 'SAG' },
                            { value: '2', text: 'SITH' },
                            { value: '3', text: 'MIXED' }
            ]
                }
        },
        {
        key: 'materialDirection',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialDirection',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: 'R' },
                            { value: '2', text: '3rd' },
                            { value: '3', text: 'P' }
            ]
                }
        },
        {
        key: 'materialNumber',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialQuantity',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'released',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.released',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.createdByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'isLocked',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.isLocked',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        }
    ]
const listViewVoConfigs = [
        {
        key: 'enNetwork',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enNetwork',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'spiridonActivityId',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.spiridonActivityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enNetworkCode',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enNetworkCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enActivityId',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enActivityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enElementName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enElementName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enElementType',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enElementType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'spiridonActivityName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.spiridonActivityName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'engineerName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.engineerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'technicianName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.technicianName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'participateAssembly',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.participateAssembly',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'scope',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.scope',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: 'SAG' },
                            { value: '2', text: 'SITH' },
                            { value: '3', text: 'MIXED' }
            ]
                }
        },
        {
        key: 'materialDirection',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialDirection',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: 'R' },
                            { value: '2', text: '3rd' },
                            { value: '3', text: 'P' }
            ]
                }
        },
        {
        key: 'materialNumber',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialQuantity',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.createdByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'isLocked',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.isLocked',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        }
    ]
const allInfoViewVoConfigs = [
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.projectName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enNetwork',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enNetwork',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'spiridonActivityId',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.spiridonActivityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enNetworkCode',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enNetworkCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enActivityId',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enActivityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enElementName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enElementName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enElementType',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enElementType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'spiridonActivityName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.spiridonActivityName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'engineerName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.engineerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'technicianName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.technicianName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'participateAssembly',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.participateAssembly',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'scope',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.scope',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: 'SAG' },
                            { value: '2', text: 'SITH' },
                            { value: '3', text: 'MIXED' }
            ]
                }
        },
        {
        key: 'materialDirection',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialDirection',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: 'R' },
                            { value: '2', text: '3rd' },
                            { value: '3', text: 'P' }
            ]
                }
        },
        {
        key: 'materialNumber',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialQuantity',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.createdByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'sapAssignStatusTranslate',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.sapAssignStatusTranslate',
        sortable: true,
            translateFromField: 'sapAssignStatus',
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'isLocked',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.isLocked',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        }
    ]
    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.projectName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectMachine1',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.projectMachine1',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'network',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.network',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'kamId',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.kamId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enNetwork',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enNetwork',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'spiridonActivityId',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.spiridonActivityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enNetworkCode',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enNetworkCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enActivityId',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enActivityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enElementName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enElementName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enElementType',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enElementType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'spiridonActivityName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.spiridonActivityName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'baseLineStartTime',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.baseLineStartTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'baseLineEndTime',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.baseLineEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'kamDeadline',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.kamDeadline',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'completeTime',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.completeTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'timeOffset',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.timeOffset',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'completeTimeDeviation',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.completeTimeDeviation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'isOtd',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.isOtd',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'professionalCategory',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.professionalCategory',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '压缩机主机' },
                            { value: '2', text: '汽轮机主机1' },
                            { value: '3', text: '汽轮机主机2' },
                            { value: '4', text: '汽轮机主机3' },
                            { value: '5', text: '系统1' },
                            { value: '6', text: '系统2' },
                            { value: '7', text: '仪表' }
            ]
                }
        },
        {
        key: 'engineerName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.engineerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'technicianName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.technicianName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'participateAssembly',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.participateAssembly',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'scope',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.scope',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: 'SAG' },
                            { value: '2', text: 'SITH' },
                            { value: '3', text: 'MIXED' }
            ]
                }
        },
        {
        key: 'scopeTranslate',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.scopeTranslate',
        sortable: true,
            translateFromField: 'scope',
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialDirection',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialDirection',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: 'R' },
                            { value: '2', text: '3rd' },
                            { value: '3', text: 'P' }
            ]
                }
        },
        {
        key: 'materialDirectionTranslate',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialDirectionTranslate',
        sortable: true,
            translateFromField: 'materialDirection',
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialNumber',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialQuantity',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'released',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.released',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.createdByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'sapAssignStatusTranslate',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.sapAssignStatusTranslate',
        sortable: true,
            translateFromField: 'sapAssignStatus',
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'sapAssignMsg',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.sapAssignMsg',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'isLocked',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.isLocked',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'bomCompareResult',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.bomCompareResult',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'isCritical',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.isCritical',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}
const exportVoVoConfigs = [
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.projectName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectMachine1',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.projectMachine1',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enNetwork',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enNetwork',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'spiridonActivityId',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.spiridonActivityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enNetworkCode',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enNetworkCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enActivityId',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enActivityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enElementName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enElementName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'enElementType',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.enElementType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'spiridonActivityName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.spiridonActivityName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'baseLineStartTime',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.baseLineStartTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'baseLineEndTime',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.baseLineEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'kamDeadline',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.kamDeadline',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'completeTime',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.completeTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'timeOffset',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.timeOffset',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'completeTimeDeviation',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.completeTimeDeviation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'isOtd',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.isOtd',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'professionalCategory',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.professionalCategory',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '压缩机主机' },
                            { value: '2', text: '汽轮机主机1' },
                            { value: '3', text: '汽轮机主机2' },
                            { value: '4', text: '汽轮机主机3' },
                            { value: '5', text: '系统1' },
                            { value: '6', text: '系统2' },
                            { value: '7', text: '仪表' }
            ]
                }
        },
        {
        key: 'engineerName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.engineerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'technicianName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.technicianName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'participateAssembly',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.participateAssembly',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'scopeTranslate',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.scopeTranslate',
        sortable: true,
            translateFromField: 'scope',
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialDirectionTranslate',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialDirectionTranslate',
        sortable: true,
            translateFromField: 'materialDirection',
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialNumber',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialQuantity',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.materialQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.createdByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'sapAssignStatusTranslate',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.sapAssignStatusTranslate',
        sortable: true,
            translateFromField: 'sapAssignStatus',
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'isLocked',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.isLocked',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'bomCompareResult',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.bomCompareResult',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'isCritical',
        label: 'label.sith.prd.sithMesPrdProjectKam.grid.isCritical',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        }
    ]

const filter = {
    idFilter : '',
    idListFilter : [],
    kamIdListFilter : [],
    projectPlanIdFilter : '',
    projectPlanIdInFilter : [],
    kamIdFilter : '',
    projectCodeFilter : '',
    projectMachine1Filter : '',
    projectOmFilter : '',
    enNetworkFilter : '',
    enNetworkCodeFilter : '',
    enActivityIdFilter : '',
    enElementNameFilter : '',
    enElementTypeFilter : '',
    baseLineStartTimeRteFilter : '',
    baseLineStartTimeLteFilter : '',
    baseLineEndTimeRteFilter : '',
    baseLineEndTimeLteFilter : '',
    kamDeadlineRteFilter : '',
    kamDeadlineLteFilter : '',
    completeTimeRteFilter : '',
    completeTimeLteFilter : '',
    timeOffsetFilter : '',
    completeTimeDeviationFilter : '',
    isOtdFilter : '',
    professionalCategoryFilter : '',
    engineerLoginNameFilter : '',
    technicianLoginNameFilter : '',
    participateAssemblyFilter : '',
    scopeFilter : '',
    materialDirectionFilter : '',
    materialNumberFilter : '',
    materialQuantityFilter : '',
    releasedFilter : '',
    sapAssignStatusFilter : '',
    sapAssignMsgFilter : '',
    isLockedFilter : '',
    bomCompareResultFilter : '',
    createdByFilter : '',
    isCriticalFilter : '',
    remarkFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectMachine1Filter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.projectMachine1',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'enNetworkFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.enNetwork',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'enNetworkCodeFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.enNetworkCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'enActivityIdFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.enActivityId',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'enElementNameFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.enElementName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'enElementTypeFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.enElementType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'baseLineStartTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.baseLineStartTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'baseLineStartTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.baseLineStartTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'baseLineEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.baseLineEndTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'baseLineEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.baseLineEndTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'kamDeadlineRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.kamDeadlineRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'kamDeadlineLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.kamDeadlineLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'completeTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.completeTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'completeTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.completeTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'isOtdFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.isOtd',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'professionalCategoryFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.professionalCategory',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '压缩机主机' },
                { value: '2', text: '汽轮机主机1' },
                { value: '3', text: '汽轮机主机2' },
                { value: '4', text: '汽轮机主机3' },
                { value: '5', text: '系统1' },
                { value: '6', text: '系统2' },
                { value: '7', text: '仪表' }
            ]
        }
        },
        {
        key: 'engineerLoginNameFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.engineerLoginName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'technicianLoginNameFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.technicianLoginName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'participateAssemblyFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.participateAssembly',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'scopeFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.scope',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: 'SAG' },
                { value: '2', text: 'SITH' },
                { value: '3', text: 'MIXED' }
            ]
        }
        },
        {
        key: 'materialDirectionFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.materialDirection',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: 'R' },
                { value: '2', text: '3rd' },
                { value: '3', text: 'P' }
            ]
        }
        },
        {
        key: 'materialNumberFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.materialNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'sapAssignStatusFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.sapAssignStatus',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '上挂成功' },
                { value: '2', text: '上挂失败' },
                { value: '3', text: '锁定跳过' },
                { value: '4', text: '等待数据维护' },
                { value: '5', text: '等待批处理' }
            ]
        }
        },
        {
        key: 'isLockedFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.isLocked',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'isCriticalFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.isCritical',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remarkFilter',
        label: 'label.sith.prd.sithMesPrdProjectKam.filter.remark',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'projectPlanId',
        label: 'label.sith.prd.sithMesPrdProjectKam.entity.projectPlanId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdProjectPlanPrp'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'kamId',
        label: 'label.sith.prd.sithMesPrdProjectKam.entity.kamId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesMstKam'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'baseLineStartTime',
        label: 'label.sith.prd.sithMesPrdProjectKam.entity.baseLineStartTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'baseLineEndTime',
        label: 'label.sith.prd.sithMesPrdProjectKam.entity.baseLineEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'kamDeadline',
        label: 'label.sith.prd.sithMesPrdProjectKam.entity.kamDeadline',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'completeTime',
        label: 'label.sith.prd.sithMesPrdProjectKam.entity.completeTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'timeOffset',
        label: 'label.sith.prd.sithMesPrdProjectKam.entity.timeOffset',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'professionalCategory',
        label: 'label.sith.prd.sithMesPrdProjectKam.entity.professionalCategory',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '压缩机主机' },
                { value: '2', text: '汽轮机主机1' },
                { value: '3', text: '汽轮机主机2' },
                { value: '4', text: '汽轮机主机3' },
                { value: '5', text: '系统1' },
                { value: '6', text: '系统2' },
                { value: '7', text: '仪表' }
            ]
        }
        },
        {
        key: 'engineerLoginName',
        label: 'label.sith.prd.sithMesPrdProjectKam.entity.engineerLoginName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'technicianLoginName',
        label: 'label.sith.prd.sithMesPrdProjectKam.entity.technicianLoginName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        },
        {
        key: 'participateAssembly',
        label: 'label.sith.prd.sithMesPrdProjectKam.entity.participateAssembly',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'scope',
        label: 'label.sith.prd.sithMesPrdProjectKam.entity.scope',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: 'SAG' },
                { value: '2', text: 'SITH' },
                { value: '3', text: 'MIXED' }
            ]
        }
        },
        {
        key: 'materialDirection',
        label: 'label.sith.prd.sithMesPrdProjectKam.entity.materialDirection',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: 'R' },
                { value: '2', text: '3rd' },
                { value: '3', text: 'P' }
            ]
        }
        },
        {
        key: 'materialNumber',
        label: 'label.sith.prd.sithMesPrdProjectKam.entity.materialNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialQuantity',
        label: 'label.sith.prd.sithMesPrdProjectKam.entity.materialQuantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdProjectKam.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
]

export {SithMesPrdProjectKam, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs

, allInfoViewENVoConfigs, listViewENVoConfigs, listViewVoConfigs, allInfoViewVoConfigs, exportVoVoConfigs
}
